// extracted by mini-css-extract-plugin
export var HamburgerButton = "Navbar-module--HamburgerButton--TWK1Y";
export var Navbar = "Navbar-module--Navbar--OsZ6n";
export var NavbarCategoryItem = "Navbar-module--NavbarCategoryItem--7a3pi";
export var NavbarDropdown = "Navbar-module--NavbarDropdown--LNWmM";
export var NavbarDropdownOverlay = "Navbar-module--NavbarDropdownOverlay--g5qpa";
export var NavbarDropdownText = "Navbar-module--NavbarDropdownText--rPaJD";
export var NavbarMenu = "Navbar-module--NavbarMenu--AYgHC";